"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pageHeader = _interopRequireDefault(require("./pageHeader.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PageHeader = function PageHeader(_ref) {
  var title = _ref.title,
      theme = _ref.theme;
  return _react["default"].createElement("div", {
    className: _pageHeader["default"]['page-header']
  }, title);
};

PageHeader.propTypes = {
  title: _propTypes["default"].string
};
PageHeader.defaultProps = {
  title: ''
};
var _default = PageHeader;
exports["default"] = _default;